module.exports = __webpack_public_path__ + "assets/img/size-effectiveness.3ca16618.png";